import { type ParsedQs } from "qs";
import { whiteListIframeQueries } from "@/components/site-builder/modules/IframeModule/constants";

export type AllowedQueryParamKey = (typeof whiteListIframeQueries)[number];

export function filterAllowedSearchParams(queryParams: ParsedQs) {
  return Object.entries(queryParams).reduce<ParsedQs>(
    (filteredParams, [key, value]) => {
      if (whiteListIframeQueries.includes(key as AllowedQueryParamKey)) {
        filteredParams[key] = value;
      }
      return filteredParams;
    },
    {},
  );
}
